// ================================================================
// Connection — رسم خطوط dotted bezier بین nodeها
// ================================================================

import { state } from '../../core/state.js';
import { events, EVENTS } from '../../core/events.js';

const SVG_NS = 'http://www.w3.org/2000/svg';

export function renderConnections(svgEl) {
  svgEl.innerHTML = '';

  state.connections.forEach(conn => {
    const from = state.getNode(conn.fromId);
    const to = state.getNode(conn.toId);
    if (!from || !to) return;

    const x1 = from.x + 90;
    const y1 = from.y + 40;
    const x2 = to.x + 10;
    const y2 = to.y + 40;

    const midX = (x1 + x2) / 2;
    const d = `M ${x1} ${y1} C ${midX} ${y1}, ${midX} ${y2}, ${x2} ${y2}`;

    const selected = state.isConnectionSelected(conn.fromId, conn.toId);

    const g = document.createElementNS(SVG_NS, 'g');
    g.setAttribute('class', selected ? 'connection-group selected' : 'connection-group');
    g.dataset.from = conn.fromId;
    g.dataset.to = conn.toId;

    const hit = document.createElementNS(SVG_NS, 'path');
    hit.setAttribute('d', d);
    hit.setAttribute('stroke', '#000');
    hit.setAttribute('stroke-opacity', '0');
    hit.setAttribute('stroke-width', '20');
    hit.setAttribute('fill', 'none');
    hit.setAttribute('stroke-linecap', 'round');
    hit.setAttribute('class', 'connection-hit');
    hit.style.pointerEvents = 'stroke';

    const path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('d', d);
    path.setAttribute('stroke', '#A6C8FF');
    path.setAttribute('stroke-width', '3');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke-dasharray', '2 6');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('class', 'connection-line');
    path.style.pointerEvents = 'none';

    g.appendChild(hit);
    g.appendChild(path);

    g.addEventListener('click', (e) => {
      e.stopPropagation();
      state.selectConnection(conn.fromId, conn.toId);
    });

    g.addEventListener('contextmenu', (e) => {
      e.preventDefault();
      e.stopPropagation();
      state.selectConnection(conn.fromId, conn.toId);
      events.emit(EVENTS.CONTEXT_MENU_OPEN, {
        type: 'connection',
        fromId: conn.fromId,
        toId: conn.toId,
        x: e.clientX,
        y: e.clientY
      });
    });

    svgEl.appendChild(g);
  });
}
